import React, { Fragment, Component, useRef, useState, useEffect } from 'react'
import { accessRole } from "../../../../helpers/access_role"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Modal, ModalBody, ModalFooter, ModalHeader,
    Button, Label,
    Spinner,
    Progress,
    Table
} from "reactstrap"
import { Redirect, Link } from "react-router-dom"

import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import ApproveBloc from './Blocs/ApproveBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

import TableComponent from './Components/TableComponent'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return ''
};

class ApproveView extends Component {

    approveBloc = new ApproveBloc()
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.activeRef = React.createRef()
        this.inactiveRef = React.createRef()
        this.state = {
            dataForm: {},
            period: null,
            fileUrl: "",
            modal: false
        }
    }

    handlerOnSubmit = (e, values) => {
        this.setState({
            dataForm: {
                uuid: this.props.uuid
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.approveBloc.fetchApprove(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    reloadRekomendasi = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchReload(query)
    }

    handleButtonExport = async () => {
        const query = {
            uuid: this.props.uuid
        }
        this.setState({ fileUrl: "", modal: !this.state.modal })
        await this.approveBloc.fetchExport(query)
    }
    
    reloadInactiveRef = () => this.inactiveRef.current.setTokenAPI()


    componentDidMount() {
        this.indexBloc.fetchDetail({ uuid: this.props.uuid })

        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.approveBloc.exportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({ fileUrl: response.file_url })
                    }
                    break;
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ period: result.data.response })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.reloadChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                        this.reloadInactiveRef()
                    break;
                default: 
                    break;
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.approveBloc.exportChannel?.unsubscribe()
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to='/kepegawaian/pemberian_penghargaan.html' style={{ marginRight: 5 }}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                                <Button color="warning" onClick={() => this.reloadRekomendasi()} style={{ marginRight: 5 }}><i className="uil uil-refresh"></i> Generate Daftar Rekomendasi</Button>
                                <Button color="primary" onClick={() => this.handleButtonExport()} style={{ marginRight: 5 }}><i className="uil-file-download-alt"></i> Export Excel</Button>
                                <Button color="success" onClick={() => this.handlerOnSubmit()}>Selesaikan Proses</Button>
                            </div>
                            <CardTitle>
                                Detail Periode
                            </CardTitle>
                            <CardSubtitle className="mb-3">
                                Periode : {this.state.period?.award_period_year}
                            </CardSubtitle>
                            <hr />
                            <TableComponent ref={this.inactiveRef} handleInactiveSuccess={this.reloadInactiveRef} uuid={this.props.uuid}/>
                        </CardBody>
                    </Card>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />

                <Modal
                    isOpen={this.state.modal}
                    role="dialog"
                    autoFocus={true}
                    centered={true}
                    className="exampleModal"
                    tabIndex="-1"
                    toggle={() => {
                        this.setState({ modal: !this.state.modal })
                    }}
                >
                    <div className="modal-content">
                        <ModalHeader
                            toggle={() => {
                                this.setState({ modal: !this.state.modal, fileUrl: "" })
                            }}
                        >
                            Export
                        </ModalHeader>
                        <ModalBody>
                            {
                                (this.state.fileUrl == "") ?
                                    <div className="text-center">
                                        <Spinner className="m-1" color="primary" />
                                        <div>
                                            Memproses Data
                                        </div>
                                    </div> 
                                    :
                                    <>
                                        <Row className='mb-3'>
                                            <label className="col-md-4">
                                                Jenis File
                                            </label>
                                            <Col md='8'>
                                                Excel (xlsx)
                                            </Col>
                                        </Row>
                                        <Row className='mb-3'>
                                            <label className="col-md-4">
                                                Waktu Generate
                                            </label>
                                            <Col md='8'>
                                                {moment(new Date()).format("DD/MM/YYYY HH:mm")}
                                            </Col>
                                        </Row>
                                        <Row className='mb-3'>
                                            <label className="col-md-4">
                                                Link
                                            </label>
                                            <Col md='8'>
                                                <a target={"_blank"} className="btn btn-success" href={this.state.fileUrl}>
                                                    Download <i className="fa fa-download ms-1"></i>
                                                </a>
                                            </Col>
                                        </Row>
                                    </>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                type="button"
                                color="secondary"
                                onClick={() => {
                                    this.setState({ modal: !this.state.modal, fileUrl: "" })
                                }}
                            >
                            Kembali
                            </Button>
                        </ModalFooter>
                    </div>
                </Modal>
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pemberian_penghargaan.html'/>
                : null }

            </Fragment>
        )
    }
}

export default ApproveView;